import { GhostButton, Icon } from '@thetreep/travel-ui';
import { useState } from 'react';
import { Dialog, DialogTrigger, Popover } from 'react-aria-components';
import { useTranslation } from 'react-i18next';
import { tv } from 'tailwind-variants';

type Props = {
	value: string;
	size?: 'sm' | 'md';
};

const popoverClassName = tv({
	base: '',
	variants: {
		isEntering: {
			true: 'duration-200 ease-out animate-in fade-in placement-top:slide-in-from-bottom-1 placement-bottom:slide-in-from-top-1',
		},
		isExiting: {
			true: 'duration-150 ease-in animate-out fade-out placement-top:slide-out-to-bottom-1 placement-bottom:slide-out-to-top-1',
		},
	},
});

export const CopyInfoTrigger = ({ value, size = 'md' }: Props) => {
	const [isPopoverOpen, setIsPopoverOpen] = useState(false);
	const { t } = useTranslation();

	const iconSize = size === 'sm' ? 12 : 16;

	return (
		<DialogTrigger>
			<GhostButton
				aria-label={t('header.copyCTA')}
				onClick={() => {
					void navigator.clipboard.writeText(value).then(() => {
						setIsPopoverOpen(true);

						setTimeout(() => {
							setIsPopoverOpen(false);
						}, 3200);
					});
				}}
			>
				<Icon name="copy" width={iconSize} height={iconSize} />
			</GhostButton>
			<Popover
				isNonModal
				isOpen={isPopoverOpen}
				placement="top"
				offset={4}
				className={({ isEntering, isExiting }) =>
					popoverClassName({ isEntering, isExiting })
				}
			>
				<Dialog className="rounded-sm bg-neutral-gray-900 p-1 typography-text-xxs font-medium text-white">
					{t('header.copyFeedback')}
				</Dialog>
			</Popover>
		</DialogTrigger>
	);
};
